module.exports = __webpack_public_path__ + "static/media/rover-go-drive.db251257.png";